export default "__VITE_ASSET__BIILFcNH__"